import { Form, Formik } from "formik";
import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import AddButton from "../../buttons/button";
import InputField from "../../forms/input-field";
import { useDispatch } from "react-redux";
import { StoreAPersonalCreateAction } from "../../../redux/actions/store-action";
import { pincodeListAction } from "../../../redux/actions/general-action";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import SelectField from "../../forms/select-field";
import ImageField from "../../forms/images-field";
import DatePickerInput from "../../forms/date-picker";
import TabsComponent from "../../helper-components/tabs-component";

const calculateAge = (dob) => {
  if (!dob) return "";
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age >= 0 ? age : "";
};

const StorePersonalTab = ({
  id,
  setStoreData,
  storeData,
  initialValue,
  disabled = false,
}) => {
  const dispatch = useDispatch();
  const [currentTab, setCurrentTab] = useState("Residential Address");
  const [autoCountry, setAutoCountry] = useState("");

  const [autoRegion, setAutoRegion] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const pincode = initialValue?.residential_pin_code;
    if (pincode?.length === 6) {
      dispatch(
        pincodeListAction(
          pincode,
          (response) => {
            if (response?.[0]?.Status !== "Error") {
              const postOffice = response?.[0]?.PostOffice?.[0];
              setAutoCountry(postOffice?.Country ?? "");
              setAutoRegion(postOffice?.District ?? "");
            }
          },
          () => {}
        )
      );
    }
  }, [initialValue?.residential_pin_code]);

  function fetchAddressFn(pincode, setFieldValue) {
    if (pincode?.length === 6) {
      dispatch(
        pincodeListAction(
          pincode,
          (response) => {
            if (response?.[0]?.Status !== "Error") {
              const postOffice = response?.[0]?.PostOffice?.[0];
              setFieldValue("residential_country_region", postOffice?.Country ?? "");
              setFieldValue("residential_region", postOffice?.District ?? "");
            }
          },
          () => {
            setFieldValue("residential_country_region", "");
            setFieldValue("residential_region", "");
          }
        )
      );
    } else {
      setFieldValue("residential_country_region", "");
      setFieldValue("residential_region", "");
    }
  }

  const initialValues = {
    store_id: id ? id : null,
    store_status: initialValue?.store_status ?? "",
    authorised_person_name: initialValue?.authorised_person_name ?? "",
    gender: initialValue?.gender ?? "",
    phone_number: initialValue?.phone_number ?? "",
    qualifications: initialValue?.qualifications ?? "",
    experience: initialValue?.experience ?? "",
    email: initialValue?.email ?? "",
    adhar_number: initialValue?.adhar_number ?? "",
    date_of_birth: initialValue?.date_of_birth ?? "",
    firm_business_name: initialValue?.firm_business_name ?? "",
    adhar_front_pic: initialValue?.adhar_front_pic ?? "",
    adhar_back_pic: initialValue?.adhar_back_pic ?? "",
    residential_address: initialValue?.residential_address ?? "",
    residential_area: initialValue?.residential_area ?? "",
    residential_landmark: initialValue?.residential_landmark ?? "",
    residential_town_or_village: initialValue?.residential_town_or_village ?? "",
    residential_city: initialValue?.residential_city ?? "",
    residential_state: initialValue?.residential_state ?? "",
    residential_pin_code: initialValue?.residential_pin_code ?? "",
    residential_country_region: initialValue?.residential_country_region || autoCountry || "",
    residential_region: initialValue?.residential_region || autoRegion || "",
  };
  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email address"),
    adhar_number: Yup.string().matches(
      /^[0-9]{12}$/,
      "Aadhar number must be a 12-digit number"
    ),
    adhar_front_pic: Yup.string().required("Adhaar Front image is required"),
    adhar_back_pic: Yup.string().required("Adhaar Back image is required"),
  });
  const onSubmit = (values, actions) => {
    const { residential_country_region, residential_region, ...payload } = values;
    setIsSaving(true);
    dispatch(StoreAPersonalCreateAction(payload, onSuccess, onError));
  };
  const onSuccess = (data) => {
    setIsSaving(false);
    setStoreData({
      ...storeData,
      personal: data?.data,
    });
    successToast(data?.data?.message);
  };
  const onError = (data) => {
    setIsSaving(false);
    errorToast(data?.data?.message);
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      // validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue }) => {
        const age = calculateAge(values.date_of_birth);
        return (
          <Form style={{ height: "calc(100% - 5rem)" }} className="pt-5">
            <div className="flex flex-col justify-between h-full ">
              <div>
                <div className="flex flex-wrap ">
                  <div className="w-full 2xl:w-[35%] lg:w-[50%] px-5 xl:px-10">
                    <SelectField
                      isDisabled={disabled}
                      placeholder={"Select Store Status"}
                      options={statusList}
                      label={"Status"}
                      id={"store_status"}
                      name="store_status"
                      isSearchable={true}
                      errMsgContainerClass="ps-2"
                      labelWidth="10.5rem"
                    />
                    <InputField
                      isDisabled={disabled}
                      type="text"
                      name="authorised_person_name"
                      placeholder="Enter Authorised Person Name"
                      label="Authorised Person Name"
                      labelWidth="10.5rem"
                    />
                    <SelectField
                      isDisabled={disabled}
                      placeholder={"Select gender"}
                      options={genderList}
                      label={"Gender"}
                      id={"gender"}
                      name="gender"
                      isSearchable={true}
                      errMsgContainerClass="ps-2"
                      labelWidth="10.5rem"
                    />
                    <InputField
                      isDisabled={disabled}
                      type="text"
                      name="phone_number"
                      placeholder="Enter Phone Number"
                      label="Phone Number"
                      labelWidth="10.5rem"
                    />
                    <InputField
                      isDisabled={disabled}
                      type="text"
                      name="qualifications"
                      placeholder="Enter Qualifications"
                      label="Qualifications"
                      labelWidth="10.5rem"
                    />
                    <InputField
                      isDisabled={disabled}
                      type="text"
                      name="experience"
                      placeholder="Enter Experience"
                      label="Experience"
                      labelWidth="10.5rem"
                    />
                  </div>
                  <div className="w-full 2xl:w-[35%] lg:w-[50%] px-5 xl:px-10 mt-10 lg:mt-0">
                    <InputField
                      onKeyDown={() => {}}
                      isDisabled={disabled}
                      type="text"
                      name="email"
                      placeholder="Enter Email"
                      label="Email"
                      labelWidth="10.5rem"
                    />
                    <InputField
                      isDisabled={disabled}
                      type="text"
                      name="adhar_number"
                      placeholder="Enter Adhaar Number"
                      label="Adhaar Number"
                      labelWidth="10.5rem"
                    />
                    <div className="flex items-center mb-2">
                      <span
                        style={{ minWidth: "10.5rem" }}
                        className="whitespace-nowrap flex text-[var(--input-label-color)] text-[length:var(--input-label-font-size)] font-[var(--input-label-font-weight)]"
                      >
                        Date of Birth
                      </span>
                      <DatePickerInput
                        placeholder="Select Date of Birth"
                        value={values.date_of_birth}
                        onChange={(date) =>
                          setFieldValue("date_of_birth", date)
                        }
                      />
                    </div>
                    <div className="flex items-center mb-2">
                      <span
                        style={{ minWidth: "10.5rem" }}
                        className="whitespace-nowrap flex text-[var(--input-label-color)] text-[length:var(--input-label-font-size)] font-[var(--input-label-font-weight)]"
                      >
                        Age
                      </span>
                      <span className="text-[var(--input-label-color)] text-[length:var(--input-label-font-size)]">
                        {age !== "" ? `${age} years` : "—"}
                      </span>
                    </div>
                    <InputField
                      isDisabled={disabled}
                      type="text"
                      name="firm_business_name"
                      placeholder="Enter Firm/Business Name"
                      label="Firm/Business Name"
                      labelWidth="10.5rem"
                    />
                    <ImageField
                      isDisabled={disabled}
                      label="Upload Adhaar Front"
                      // isRequired={true}
                      labelWidth="10.5rem"
                      name="adhar_front_pic"
                    />
                    <ImageField
                      isDisabled={disabled}
                      label="Upload Adhaar Back"
                      // isRequired={true}
                      labelWidth="10.5rem"
                      name="adhar_back_pic"
                      mainLabel=""
                    />
                  </div>
                </div>
                <TabsComponent
                  handleClickfn={(item) => setCurrentTab(item)}
                  itemTabs={personalSubTabs}
                  setCurrentTab={setCurrentTab}
                  currentTab={currentTab}
                />
                {currentTab === "Residential Address" && (
                  <div className="w-full 2xl:w-[40%] xl:w-[50%] lg:w-[60%] px-5 xl:px-10 mt-5">
                    <InputField
                      isDisabled={disabled}
                      type="text"
                      name="residential_address"
                      placeholder="Enter Residential Address"
                      label="Address"
                      labelWidth="10.5rem"
                    />
                    <InputField
                      isDisabled={disabled}
                      type="text"
                      name="residential_area"
                      placeholder="Enter Area"
                      label="Area"
                      labelWidth="10.5rem"
                    />
                    <InputField
                      isDisabled={disabled}
                      type="text"
                      name="residential_landmark"
                      placeholder="Enter Landmark"
                      label="Landmark"
                      labelWidth="10.5rem"
                    />
                    <InputField
                      isDisabled={disabled}
                      type="text"
                      name="residential_town_or_village"
                      placeholder="Enter Town/Village"
                      label="Town/Village"
                      labelWidth="10.5rem"
                    />
                    <InputField
                      isDisabled={disabled}
                      type="text"
                      name="residential_city"
                      placeholder="Enter City"
                      label="City"
                      labelWidth="10.5rem"
                    />
                    <InputField
                      isDisabled={disabled}
                      type="text"
                      name="residential_state"
                      placeholder="Enter State"
                      label="State"
                      labelWidth="10.5rem"
                    />
                    <InputField
                      isDisabled={disabled}
                      type="text"
                      name="residential_pin_code"
                      placeholder="Enter Pin Code"
                      label="Pin Code"
                      labelWidth="10.5rem"
                      handleChange={(e) => {
                        fetchAddressFn(e?.target?.value, setFieldValue);
                      }}
                    />
                    <InputField
                      isDisabled={true}
                      type="text"
                      name="residential_country_region"
                      placeholder="Auto-filled from Pin Code"
                      label="Country"
                      labelWidth="10.5rem"
                    />
                    <InputField
                      isDisabled={true}
                      type="text"
                      name="residential_region"
                      placeholder="Enter Region"
                      label="Region"
                      labelWidth="10.5rem"
                    />
                  </div>
                )}
              </div>
              {!disabled && (
                <div
                  style={{
                    bottom: "0",
                  }}
                  className="flex justify-end px-10 mb-5x sticky bg-white py-4 invoice-bottom-container"
                >
                  <AddButton
                    prefixIcon={false}
                    text="Save"
                    type="submit"
                    loading={isSaving}
                  />
                </div>
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default StorePersonalTab;
const personalSubTabs = ["Residential Address"];
const statusList = [
  {
    label: "Hold",
    value: "hold",
  },
  {
    label: "Reject",
    value: "reject",
  },
  {
    label: "Approved",
    value: "approved",
  }
];
const genderList = [
  {
    label: "Male",
    value: "male",
  },
  {
    label: "Female",
    value: "female",
  },
];